import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import Vuex from 'vuex'

Vue.use(ElementUI);
Vue.use(Vuex)
const username_key = 'username'
const mobile_key = 'mobile'
const publish_key = 'publish_items'
const store = new Vuex.Store({
  state: {
    username: localStorage.getItem(username_key) || '',
    mobile: localStorage.getItem(mobile_key) || '',
    publishItems: localStorage.getItem(publish_key) ? JSON.parse(localStorage.getItem(publish_key)) : []
  },
  mutations: {
    login (state, user) {
      state.username = user.username
      state.mobile = user.mobile
      localStorage.setItem(username_key, user.username)
      localStorage.setItem(mobile_key, user.mobile)
      console.log('login: ', user)
    },
    logout (state) {
      state.username = ''
      state.mobile = ''
      localStorage.setItem(username_key, '')
      localStorage.setItem(mobile_key, '')
    },
    addItem (state, item) {
      state.publishItems.push(item)
      localStorage.setItem(publish_key, JSON.stringify(state.publishItems))
    }
  },
  getters: {
    username(state) {
      return state.username
    },
    mobile(state) {
      return state.mobile
    },
    publishItems(state) {
      return state.publishItems
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Layout)
});
